import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, Fragment as _Fragment } from "vue"
import _imports_0 from '@/app/ui/assets/svg/arrow-left.svg'


const _hoisted_1 = { class: "flex flex-row justify-between items-center py-2 pr-4 pl-6" }
const _hoisted_2 = { class: "flex flex-row items-center gap-2" }
const _hoisted_3 = { class: "text-black-lp-100 text-2xl font-bold" }
const _hoisted_4 = { class: "flex flex-row gap-2 items-center" }
const _hoisted_5 = { class: "bg-gray-lp-1200 py-2 px-4 h-full overflow-y-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_lp_button = _resolveComponent("lp-button")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, { to: "/cargo-v2/create" }, {
          default: _withCtx(() => [
            _createVNode("img", {
              src: _imports_0,
              class: "w-6 cursor-pointer",
              alt: _ctx.$t('cargoV2.create.common.backAlt')
            }, null, 8, ["alt"])
          ]),
          _: 1
        }),
        _createVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("cargoV2.create.nonRtcLayout.title")), 1)
      ]),
      _createVNode("div", _hoisted_4, [
        (_ctx.isShowSearchFlightBtn)
          ? (_openBlock(), _createBlock(_component_lp_button, {
              key: 0,
              title: _ctx.$t('cargoV2.create.common.selectSchedule'),
              "data-testid": "cargo-v2-manual-button-select-schedule",
              outline: "",
              textColor: "red-lp-100",
              color: "red-lp-100",
              disabled: _ctx.isDisabledSearchFlightBtn,
              onClick: _cache[1] || (_cache[1] = () => _ctx.$emit('search-flight'))
            }, null, 8, ["title", "disabled"]))
          : _createCommentVNode("", true),
        _createVNode(_component_lp_button, {
          title: _ctx.$t('cargoV2.create.common.booking'),
          "data-testid": "cargo-v2-manual-button-booking",
          textColor: "white",
          color: "red-lp-100",
          disabled: _ctx.isDisabledBookingBtn,
          onClick: _cache[2] || (_cache[2] = () => _ctx.$emit('booking'))
        }, null, 8, ["title", "disabled"])
      ])
    ]),
    _createVNode("div", _hoisted_5, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 64))
}